import React from 'react'
import { ControlLabel } from '../label/Label'
import InputPrice from '../inputs/InputPrice'
import './labeledInput.scss'

const LabeledPrice = ({
  classNameBox,
  idLabel,
  required,
  onChange,
  ...propsInput
}) => {
  return (
    <div className={`flex-container ${classNameBox}`}>
      <ControlLabel id={idLabel} required={required} />
      <div className="control-input">
        <InputPrice onChange={onChange} {...propsInput} />
      </div>
    </div>
  )
}
export default LabeledPrice
